const fctKey = {
    install(Vue) {
        //Obtenir le credential de connection à l'api Omni-C
        Vue.prototype.$CKey =  function() {
            return Buffer.from(`${this.$store.getters.getApiAdd.key.user}:${this.$store.getters.getApiAdd.key.pass}`, 'utf8').toString('base64') ;
            //return 'allo123'
        }
    }
}
    
export default fctKey